import mlFunctionsClient from '../interceptor.mlFunctionsClient';

const routeReconstructionEndpoints = {
  getHistory: (config) =>
    mlFunctionsClient.get('/GetRouteHistory', config),
};

export default routeReconstructionEndpoints;
